<div class="wishlist">
  <div class="d-flex align-items-center justify-content-between flex-wrap">
    <h1>
      {{ 'account.wishlists.heading' | translate }}
      <ng-template #WishlistDescription>
        <span innerHTML="{{ 'account.wishlists.heading.tooltip.content' | translate }}"></span>
      </ng-template>
      <button
        type="button"
        class="btn btn-link details-tooltip header-note mt-1"
        [ngbPopover]="WishlistDescription"
        placement="bottom"
        popoverTitle="{{ 'account.wishlists.heading.tooltip.headline' | translate }}"
      >
        {{ 'account.wishlists.heading.tooltip.link' | translate }}
        <fa-icon [icon]="['fas', 'info-circle']" />
      </button>
    </h1>

    <button
      type="button"
      class="btn btn-secondary m-0"
      data-testing-id="add-wishlist"
      (click)="addWishlistDialog.show()"
    >
      {{ 'account.wishlists.add_wishlist' | translate }}
    </button>
  </div>
  <!-- Error message -->
  <ish-error-message [error]="wishlistError$ | async" />

  <div>
    <ish-account-wishlist-list [wishlists]="wishlists$ | async" (deleteWishlist)="deleteWishlist($event)" />
  </div>

  <a routerLink="/home">{{ 'account.wishlist.searchform.continue_shopping.link' | translate }}</a>
</div>

<ish-wishlist-preferences-dialog #addWishlistDialog (submitWishlist)="addWishlist($event)" />

<ish-loading *ngIf="wishlistLoading$ | async" />
